import { useEffect, useState } from 'react';
import { fetchStatus, type StatusPayload } from './lib/api';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import OverallBanner from './components/OverallBanner';
import ServiceGroup from './components/ServiceGroup';
import IncidentLog from './components/IncidentLog';

const GROUP_ORDER = ['Platform', 'Game Nodes', 'Network', 'Edge', 'External', 'Sponsored'];

function sortGroups(payload: StatusPayload) {
  const sorted = [...payload.groups].sort((a, b) => {
    const ai = GROUP_ORDER.indexOf(a.name);
    const bi = GROUP_ORDER.indexOf(b.name);
    if (ai === -1 && bi === -1) return a.name.localeCompare(b.name);
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });
  return { ...payload, groups: sorted };
}

export default function App() {
  const [payload, setPayload] = useState<StatusPayload | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    const load = () => fetchStatus()
      .then((p) => { if (alive) { setPayload(sortGroups(p)); setErr(null); } })
      .catch((e) => { if (alive) setErr(String(e)); });
    load();
    const t = setInterval(load, 30_000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return (
    <>
      <Navbar />
      <main className="container pb-16">
        {err && !payload ? (
          <section className="pt-28 md:pt-32">
            <div className="card text-sm text-offwhite/80">
              Status data is briefly unavailable. Retrying.
            </div>
          </section>
        ) : !payload ? (
          <section className="pt-28 md:pt-32">
            <div className="card text-sm text-offwhite/55">Loading status data.</div>
          </section>
        ) : (
          <>
            <OverallBanner status={payload.overall} updatedAt={payload.updated_at} />
            {payload.groups.map((g) => <ServiceGroup key={g.name} group={g} />)}
            <IncidentLog />
          </>
        )}
      </main>
      <Footer />
    </>
  );
}
